import { __decorate, __metadata } from "tslib";
import { LengthWithLVS } from '@goparrot/common';
import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsNotEmpty, IsString } from 'class-validator';
import { WebMerchantExposeGroup } from '../interface';
export class ReadWebMerchantThemeColorsDto {
}
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "text", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "primary", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "secondary", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "tertiary", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "primaryColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "secondaryColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "tertiaryColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "headerColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "buttonColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "primaryButtonColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "primaryButtonColorHover", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "primaryButtonColorInactive", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "secondaryButtonColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "secondaryButtonColorHover", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "secondaryButtonColorInactive", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "tertiaryButtonColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "tertiaryButtonColorHover", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "tertiaryButtonColorInactive", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "buttonTextColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "primaryButtonTextColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "primaryButtonTextColorInactive", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "secondaryButtonTextColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "secondaryButtonTextColorInactive", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "tertiaryButtonTextColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "tertiaryButtonTextColorInactive", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "buttonBorderColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "primaryButtonBorderColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "primaryButtonBorderColorInactive", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "secondaryButtonBorderColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "secondaryButtonBorderColorInactive", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "tertiaryButtonBorderColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "tertiaryButtonBorderColorInactive", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "background", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "primaryBackground", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "secondaryBackground", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "tertiaryBackground", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "foreground", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "black", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "white", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "gray", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "gray50", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "gray100", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "gray200", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "gray300", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "gray400", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "gray500", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "gray600", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "gray700", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "gray800", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "gray900", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "danger", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "success", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "warning", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "buttonBgColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "transparent", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "emphasisText", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "emphasis40", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "emphasis30", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "emphasisFill", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "warningText", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "warning40", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "warning30", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "warningFill", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "criticalText", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "critical40", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "critical30", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "criticalFill", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "successText", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "success40", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "success30", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantThemeColorsDto.prototype, "successFill", void 0);
//# sourceMappingURL=ReadWebMerchantThemeColorsDto.js.map